<template>
  <div>
    <div class="d-inline-block">
    <span class="caption font-weight-bold d-inline-block">
      <px-forma-pagamento :forma-pagamento="prazo.formaPagamento"
                          :prazo-pagamento="prazo.prazoPagamento"/>
    </span>
      <v-btn icon x-small class="ml-1" :color="color" @click="onChange">
        <v-icon>{{ icon }}</v-icon>
      </v-btn>
    </div>
    <px-input-money
      dense
      class="required"
      ref="precoUnitario"
      :label="labelPreco"
      :disabled="!isRespondida"
      :error="$v.prazo.precoUnitario.$error"
      @blur="$v.prazo.precoUnitario.$touch()"
      v-model="prazo.precoUnitario"/>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import validationMixin from '@/mixins/validation-mixin';
import { SituacaoRespostaPrazo } from 'px-business-components';

export default {
  mixins: [validationMixin],
  props: {
    prazo: Object,
    produto: Object,
  },
  computed: {
    labelPreco() {
      return `Preço por ${this.produto.cotacaoConjuntaProduto.unidadeMedida.descricao}`;
    },
    isRespondida() {
      return this.prazo.situacao === SituacaoRespostaPrazo.keys.RESPONDIDA.key;
    },
    icon() {
      if (this.isRespondida) {
        return 'mdi-close';
      }
      return 'mdi-undo-variant';
    },
    color() {
      if (this.isRespondida) {
        return 'error';
      }
      return 'success';
    },
  },
  methods: {
    updateValues() {
      if (this.prazo.precoUnitario) {
        this.$refs.precoUnitario.$el.getElementsByTagName('input')[0].value = 0;
        this.prazo.precoUnitario = 0;
      }
    },
    onChange() {
      this.updateValues();

      if (this.isRespondida) {
        this.prazo.situacao = SituacaoRespostaPrazo.keys.NAO_FORNECE.key;
        return;
      }
      this.prazo.situacao = SituacaoRespostaPrazo.keys.RESPONDIDA.key;
    },
  },
  validations() {
    if (!this.isRespondida) {
      return {
        prazo: {
          precoUnitario: {},
        },
      };
    }

    return {
      prazo: {
        precoUnitario: {
          required,
          minValue: (value) => value > 0,
        },
      },
    };
  },
};
</script>
